import { requester } from '../utils';

export const fetchAllCompletedReservesReport = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/reserve/archive/cafes?${query}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};
